import { trafficPeriodDetailed } from '@app/pcs/models';
import {gql} from 'apollo-angular';

export const deleteTrafficPeriodsMutation = gql`
    mutation DeleteTrafficPeriod($trafficPeriodIds: [Long]!) {
        deleteTrafficPeriod (trafficPeriodIds: $trafficPeriodIds)
    }
`;

export const saveTrafficPeriodMutationResult = 'saveTrafficPeriod';
export const saveTrafficPeriodMutation = gql`
    mutation SaveTrafficPeriod($trafficPeriod: TrafficPeriodInput!) {
        saveTrafficPeriod (trafficPeriod: $trafficPeriod) {
            ...trafficPeriodDetailed
        }
    }
    ${trafficPeriodDetailed}
`;
